import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-product-configuration',
  templateUrl: './create-product-configuration.component.html',
  styleUrls: ['./create-product-configuration.component.scss']
})
export class CreateProductConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
